import { render, staticRenderFns } from "./moveTask.vue?vue&type=template&id=35633eee&scoped=true&"
import script from "./moveTask.js?vue&type=script&lang=js&"
export * from "./moveTask.js?vue&type=script&lang=js&"
import style0 from "./moveTask.scss?vue&type=style&index=0&id=35633eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35633eee",
  null
  
)

export default component.exports